import { Power0, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import { bindInViewTimelineStagger } from '../util/animations'

class EntryListed {
  constructor ($el, masterTimeline) {
    this.$el = $el
    this.imgFilter = { blur: 0 }
    if (typeof $el.data('animateIn') === 'undefined' || $el.data('animateIn') === true) {
      this.timelineIn = new TimelineMax({ paused: true, onComplete: () => { this.$el.data('animateInDone', true) } })
      this.buildTimelineIn()
      this.$el.data('offset', '95%')
      bindInViewTimelineStagger($el, this.timelineIn, masterTimeline)
    }
    this.timelineHover = new TimelineMax({ paused: true })
    this.buildTimelineHover()
  }

  buildTimelineIn () {
    this.timelineIn
      .fromTo(
        this.$el.findElement('title'),
        0.8,
        { y: '100%' },
        { y: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        this.$el.findElement('title'),
        0.8,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0
      )
      .fromTo(
        this.$el.findElement('image'),
        0.8,
        { y: '-100%' },
        { y: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        this.$el.findElement('image').find('.static-image'),
        0.8,
        { y: '100%' },
        { y: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        this.$el.findElement('image').find('.static-image'),
        0.3,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0
      )
  }

  buildTimelineHover () {
    const $el = this.$el
    // const $staticImageImg = this.$el.findElement('image').find('.static-image')
    this.timelineHover
      .to(
        this.$el.findElement('image').find('.hover-image'),
        0.4,
        { y: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        this.$el.findElement('image').find('.hover-image img'),
        0.4,
        { y: '-100%', scale: 1.3 },
        { y: '0%', scale: 1.35, ease: Power3.easeInOut },
        0
      )
      .to(
        this.$el.findElement('title'),
        0.4,
        { y: '-10px', ease: Power3.easeInOut },
        0
      )

    $el.data('timelineHover', this.timelineHover)
  }
}

export default EntryListed



// WEBPACK FOOTER //
// ./scripts/components/EntryListed.js